ready(function(){

	// -- variables --
	const yDist = 40;
	gsap.defaults({'ease': 'power4.out'});	  
	const tlMaster = gsap.timeline();

	// -- add function to main timeline --
	if (document.body.classList.contains('type--home')) {
		// -- homepage > set --
		gsap.set(['.header__navbar'], {autoAlpha: 0, y: -yDist});
		gsap.set(['.heading-wrapper','.glide__nav'], {autoAlpha: 0, y: yDist});
		gsap.set(['.glide.type--bannersMatrix .glide__track'], {x: '100vw', y: '-100vh'});
		// gsap.set(['.btn--showVideo'], {scale: 0.9});
		gsap.set(['.showMatrixBlock .stagger'], {autoAlpha: 0, y: yDist*1.5, scale: 0.9});
		gsap.set('.gsap-draw', {drawSVG: "50% 50%"});
		// -- homepage > timeline
		tlMaster.add(loader);
		tlMaster.to('.loader', 1, {yPercent: -100, scale: 0}, '<2');
		tlMaster.to(['.header','.main','.footer'], 0.8, {autoAlpha: 1}, '<0.2');
		// tlMaster.from('.bannerVideo', 1.5, {autoAlpha: 0, yPercent: 100},'<0.2');
		tlMaster.add(bannerVideo);
	} else {
		// -- webpage > set --
		gsap.set(['.header__navbar'], {autoAlpha: 0, y: -yDist});
		// gsap.set(['.heading-wrapper'], {autoAlpha: 0, y: yDist});
		// -- webpage > timeline --		
		tlMaster.add(loader);
		tlMaster.to('.loader', 1, {yPercent: -100, scale: 0}, '<2');
		tlMaster.to(['.header','.main','.footer'], 0.8, {autoAlpha: 1}, '<0.2');
		tlMaster.from('.banner', 0.8, {autoAlpha: 0, yPercent: 100},'<0.2');
		tlMaster.add(banner);
	}


	// -- functions --
	function loader() {
		const luxSvgPath = document.querySelectorAll('.luxSvg path');
		const tl = gsap.timeline({defaults: {duration: 0.4, stagger: 0.15}, repeat: -1});
		luxSvgPath.forEach((path) => {
			gsap.set(path, {autoAlpha:0, x: path.dataset.x, y: path.dataset.y});
		});
		tl.to('.luxSvg path', {autoAlpha:1, x: 0, y: 0});
		return tl;
	}


	function banner() {
		const tl = gsap.timeline({ defaults: {duration: 0.4, delay: 0.2}, onComplete: activeScroll });
		tl.to(['h1', '.header__navbar'], {autoAlpha: 1, y: 0, stagger: 0.2});
		return tl;
	}


	function bannerVideo() {
		const tl = gsap.timeline({ defaults: {duration: 0.8}, onComplete: activeScroll });
		// tl.add(bannerVideoSplitText);
		tl.to('.glide.type--bannersMatrix .glide__track', {x: 0, y: 0});
		tl.to('.heading-wrapper', {autoAlpha: 1, y: 0}, '<0.2');
		tl.to(['.header__navbar','.glide__nav'], {autoAlpha: 1, y: 0});
		// tl.to('.btn--showVideo', 1.5, {autoAlpha: 1, y: 0, scale: 1, onComplete: openPortrait});
		return tl;
	}


	function bannerVideoSplitText(){
		const words = document.querySelectorAll('.word');
		words.forEach((word) => {
			const letters = word.textContent.split('');
			word.textContent = '';
			letters.forEach((letter) => {
				const span = document.createElement('span');
				span.textContent = letter;
				span.className = 'letter';
				word.append(span);
			});
		});

		const tl = gsap.timeline({ defaults: {duration: 0.4, stagger: 0.05}, repeat: -1 });
		words.forEach((word) => {
			tl.from(word.childNodes, {y: -100, skewX: '50deg', ease: 'expo.out'});
			tl.to(word.childNodes, {delay: 1, y: 100, skewX: '-50deg', ease: 'expo.in' });
		});
	}


	function activeScroll() {
		const bodyInner = document.querySelector('.body__inner');
		bodyInner.classList.remove('h-app');
		ScrollTrigger.refresh();
	  if (window.location.hash) {
    	scrollIntoView(window.location.hash);
    }
	}


  function scrollIntoView(targetId){
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
      setTimeout(function(){
       targetElement.focus();
      }, 400);
    }    
  }


	function showMatrixBlock(){
		const blocks = gsap.utils.toArray('.showMatrixBlock');
		blocks.forEach(block => {
			const staggers = block.querySelectorAll('.stagger');
			if (staggers.length) {
				gsap.to(staggers, 1.5, {
					autoAlpha: 1,
					y: 0,
					scale: 1,
					stagger: 0.2,
					ease: 'power3.out',
					scrollTrigger: {
						trigger: block,
						start: 'top 80%',
						toggleActions: "play none none reverse",
	 					onToggle: self => {
	 						if (self.isActive == true) {
	 							self.trigger.classList.add('active');
	 						} else {
	 							self.trigger.classList.remove('active');
	 						}
	 					},
						// onEnter: self => {
						// 	if (self.trigger.classList.contains('blockGallery')) {
						// 		shuffle();
						// 	}
						// },
						// onLeave: self => {
						// 	if (self.trigger.classList.contains('blockGallery')) {
						// 		shuffle();
						// 	}
						// },
					}
				});
			}
		});		
	}
	showMatrixBlock();


	function blockGallery(){
		const blocks = gsap.utils.toArray('.blockGallery');
		if (blockGallery) {
			blocks.forEach(block => {
				gsap.to(block, {
					scrollTrigger: {
						trigger: block,
						start: 'top 80%',
						onEnter: shuffle,
						onLeave: shuffle,
					}
				});
			});
		}
	}
	blockGallery();


	function drawIcons(){
		const icons = gsap.utils.toArray('.gsap-draw');
		if (icons) {
			icons.forEach(icon => {
				gsap.to(icon, 3, {
					drawSVG: "100%",
					scrollTrigger: {
						start: 'top center',
						trigger: icon,
						toggleActions: "play none none reverse",
					},
					delay: 1
				});
			});
		}
	}
	drawIcons();


	function anniversaryGameCTA() {
		const cta = document.querySelector('[data-anniversary-game-cta]');
		if (!cta) {
			return;
		}

		const card = cta.querySelector('.anniversaryGameCTA__card');
		const trigger = cta.querySelector('.anniversaryGameCTA__trigger');
		let hasRevealed = false;

		if (typeof ScrollTrigger === 'undefined') {
			cta.open = true;
			gsap.set(cta, {autoAlpha: 1, x: 0, pointerEvents: 'auto'});
			return;
		}

		gsap.set(cta, {autoAlpha: 0, x: yDist * 1.5, pointerEvents: 'none'});

		ScrollTrigger.create({
			trigger: '.main',
			start: 'top+=160 top',
			once: true,
			onEnter: () => {
				if (hasRevealed) {
					return;
				}

				hasRevealed = true;
				cta.open = true;

				const tl = gsap.timeline();
				tl.set(cta, {pointerEvents: 'auto'});
				tl.to(cta, 0.8, {autoAlpha: 1, x: 0, ease: 'back.out(1.15)'});
				if (card) {
					tl.from(card, 0.45, {y: 24, ease: 'power3.out'}, '<0.08');
				}
			}
		});

		if (trigger && card) {
			trigger.addEventListener('click', function(){
				requestAnimationFrame(() => {
					if (cta.open) {
						gsap.fromTo(card, {y: 18}, {y: 0, duration: 0.35, ease: 'power3.out'});
					}
				});
			});
		}
	}
	anniversaryGameCTA();


	// function brandIcon(){
	// 	const $brandIcon = document.querySelector('.brandIcon');
	// 	if ($brandIcon) {
	// 		gsap.to('.brandIcon', 2, {
	// 			autoAlpha: 1,
	// 			yPercent: -20,
	// 			maxHeight: 'fit-content',
	// 			scrollTrigger: {
	// 				start: 'top center',
	// 				trigger: '.blockTextWithIcon',
	// 				toggleActions: "play none none reverse",
	// 			}
	// 		});
	// 	}
	// }
	// brandIcon();


	function buttonFilledHover(){
		const buttons = document.querySelectorAll('.btn--filled');
		buttons.forEach(button => {
			const buttonIcon = button.querySelector('.icon');
			const buttonText = button.querySelector('.text');
			const tl = gsap.timeline({ defaults: {'duration': 0.4, 'ease': 'power4.easeInOut'} });

			tl.to(button, {skewX: '10deg'});
			tl.to(buttonText, {'letterSpacing': '1.2px', skewX: '-10deg'}, 0);
			tl.to(buttonIcon, 0.2, {autoAlpha: 0, y: yDist, skewX: '-10deg'}, 0);
			tl.to(buttonIcon, 0.05, {autoAlpha: 0, y: -yDist, skewX: '-10deg'}, '>-0.01');
			tl.to(buttonIcon, 0.2, {autoAlpha: 1, y: 0, skewX: '-10deg'}, '>-0.01');
			tl.pause();

		  button.addEventListener('mouseenter', function(){
		  	tl.play();
		  });
		  button.addEventListener('mouseleave', function(){
		  	tl.reverse();
		  });
		});
	}
	buttonFilledHover();


	// -- utils function --
	function shuffle(){
		setTimeout(function(){
			if (glideGalleries[0]) {
				glideGalleries[0].go('>');
			}
			if (glideGalleries[1]) {
				glideGalleries[1].go('<');
			}
		}, 800);
	}
	function getAnchor() {
		var url = window.location.href,
		urlSplit = url.split('#');
		return (urlSplit.length > 1) ? urlSplit[1] : null;
	}	
	function openPortrait(){
		if (getAnchor() != null) {
			setTimeout(function(){
				const portraitEl = document.querySelector('#'+getAnchor());
				// -- scrollTo portrait --
				portraitEl.scrollIntoView({behavior: 'smooth'});
				// -- goTo portrait --
				var index = getAnchor().split('-')[1];
				glideGalleryTypeFan.go('='+index);
			}, 100);
		}
	}

});
